import ContentLayout from "@/layouts/ContentLayout";
import HeaderBackButton from "@/components/HeaderBackButton";
import TaskEditableTitle from "./components/TaskEditableTitle";
import TaskInfo from "./components/TaskInfo";

export default function TaskDetail() {
  return (
    <ContentLayout>
      <HeaderBackButton url="/management/tasks" useBrowserBack={true} />
      <TaskEditableTitle />
      <TaskInfo />
    </ContentLayout>
  );
}
